export default __webpack_public_path__ + "d4b6b11dde5c166e1c931eca168189a6.twig";